export default {
  'claims': 'Réclamers',
  'claims_v2': 'Réclamers v2',
  'operationalReports': 'Rapports Opérationnels',
  'reports': 'Rapports',
  'claimSearch': 'Recherche de Réclamation',
  'claimSearch_v2': 'Recherche de Réclamation v2',
  'dealerRegistration': 'Inscription du concessionnaire',
  'addProducts': 'Ajouter des produits',
  'registerDealer': 'Inscrire un revendeur',
  'dealerSubmissions': 'Soumissions des concessionnaires',
};